import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveFolderStructure() {
      try {
        const structure = await axios.get('/folder-structure', { withCredentials: true });
        return structure.data;
      } catch (error) {
        throw error;
      }
    },
    // async createAppPermission(context, data) {
    //   try {
    //     const config = { withCredentials: true };
    //     const response = await axios.post('/app-permissions', data, config);
    //     return response.data;
    //   } catch (error) {
    //     throw error;
    //   }
    // },
    async updateFolderStructure(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.patch(`/folder-structure/${data.type}`, data.data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
